<template>
  <div :id="smsCode ? 'client' : 'mobile'">
    <VanConfigProvider theme-vars-scope="global">
      <router-view v-slot="{ Component }">
        <keep-alive :include="cacheNameList">
          <component :is="Component" />
        </keep-alive>
      </router-view>
    </VanConfigProvider>
  </div>
</template>

<script setup>
import { useCacheH5RouteStore } from "@/store/modules/h5/cacheRoute.js";
import { useRoute } from 'vue-router';
import { storeToRefs } from 'pinia';
import { wxJsSdkInit } from '@/utils/wxJsSdk.js';

initViewPort()

function initViewPort() {
  const metaViewport = document.createElement('meta');
  metaViewport.name = 'viewport';
  metaViewport.content = 'width=device-width, initial-scale=1.0, maximum-scale=1, viewport-fit=cover';
  document.head.appendChild(metaViewport);
}

const cacheH5RouteStore = useCacheH5RouteStore()
const { cacheNameList } = storeToRefs(cacheH5RouteStore)
const route = useRoute();
const clientData = ref(JSON.parse(sessionStorage.getItem('__clientData__') || '{}'));
const smsCode = ref(clientData.value.smsCode);

</script>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  async beforeRouteEnter(to, from, next) {
    try {
      await wxJsSdkInit();
    } finally {
      next();
    }
  },
});
</script>

<style lang="scss" scoped>
#mobile{
  width: 100%;
  height: 100%; /* 改用百分比，依赖父元素html/body的100%高度 */
  min-height: 100vh; /* 兜底兼容，确保在现代浏览器中生效 */
  box-sizing: border-box; /* 避免padding/border撑开尺寸 */
}
</style>
